import once from "lodash.once";

export enum EDeviceType {
	Desktop = "Desktop",
	Mobile = "Mobile",
	Tablet = "Tablet",
	Unknown = "Unknown",
}

export const isMobile = () => {
	if (typeof window !== "undefined") {
		return "ontouchstart" in document.documentElement && navigator.userAgent.match(/Mobi/);
	}
	return false;
};

export const getDeviceType = (): EDeviceType => {
	if (typeof navigator === "undefined") {
		return EDeviceType.Unknown;
	}

	const { maxTouchPoints, userAgent } = navigator;
	const isIpadOS = userAgent.includes("Macintosh") && maxTouchPoints > 1;
	const isAndroidTablet = userAgent.includes("Android") && !userAgent.includes("Mobile");
	const isTablet = /iPad|Tablet|PlayBook|Silk|Kindle/i.test(userAgent) || isIpadOS || isAndroidTablet;

	if (isTablet) {
		return EDeviceType.Tablet;
	}

	if (/Mobi|iPhone|iPod|IEMobile|Windows Phone|Android/i.test(userAgent)) {
		return EDeviceType.Mobile;
	}

	return EDeviceType.Desktop;
};

export const isAppleDevice = () => /Macintosh|MacIntel|MacPPC|Mac68K|iPhone|iPod|iPad/.test(navigator.userAgent);

/**
 * Returns `true` if a `Safari` browser.
 * Returns `true` if the browser is running on iOS (they are all Safari).
 * */
export const isSafari = once(function isSafari(): boolean {
	const { userAgent } = navigator;
	return userAgent.includes("AppleWebKit") && !userAgent.includes("Chrome");
});
